module.exports = __webpack_public_path__ + "static/img/9.4a5214d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/4/sp/9.png
// module id = HL8h
// module chunks = 0